import React from 'react'

import './style.css'
import {Card, Col, Row} from "antd";
import {DEFAULT_GUTTER} from "../../constants";
import {useTranslations} from "../../lang";
import ReadMore from "../ReadMore";

export default function ProfileHeader({company}) {
    const {translate} = useTranslations();

    if (!company) {
        return null;
    }

    return (
        <>
            {company.header_image && company.logo && (
                <div className={"profile-header mar-b-1"} style={{backgroundImage: `url(${company?.header_image})`}}>
                    <div className={"profile-logo-in-header"} style={{textAlign: 'center'}}>
                        <img src={company?.logo} alt={company?.name}/>
                    </div>
                </div>
            )}
            {company.header_image && !company.logo  && (
                <div className={"profile-header mar-b-1"} style={{backgroundImage: `url(${company?.header_image})`}}>

                </div>
            )}

            <Card style={{background: 'white'}} className={"mar-b-1"}>
                <Row gutter={DEFAULT_GUTTER} className={"mar-b-1"}>
                    <Col md={24} xs={24}>
                        <h1>{translate('Over')} {company?.name}</h1>
                        <div className={"mar-t-1 mar-b-1"}>
                            <ReadMore text={company?.description}/>
                        </div>
                        {!company?.description && (
                            <p>{translate('Er is nog geen beschrijving geplaatst.')}</p>
                        )}
                    </Col>
                </Row>
            </Card>
        </>
    )
}